import { render } from "./InShip.vue?vue&type=template&id=d232b29c"
import script from "./InShip.vue?vue&type=script&lang=js"
export * from "./InShip.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__